import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    OnChanges,
    OnDestroy,
    OnInit, SimpleChanges,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {CommonModule, DatePipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle} from "@angular/material/card";
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell, MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef, MatNoDataRow,
    MatRow, MatRowDef, MatTable, MatTableDataSource
} from "@angular/material/table";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatMenu, MatMenuPanel, MatMenuTrigger} from "@angular/material/menu";
import {MatOption} from "@angular/material/autocomplete";
import {MatPaginator} from "@angular/material/paginator";
import {MatSelect} from "@angular/material/select";
import {MatSort, MatSortHeader} from "@angular/material/sort";
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {MatTooltip} from "@angular/material/tooltip";
import {CookieService} from "ngx-cookie-service";
import {DialogService} from "../../_modal/dialog.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {CustomizerSettingsService} from "../../../customizer-settings/customizer-settings.service";
import {OverlayContainer} from "@angular/cdk/overlay";
import {HandleErrorsService} from "../../../services/handle-erros/handle.errors.service";
import {environment} from "../../../../environments/environment";
import {OT_DTO} from "../../_models/OT_DTO";
import {RapportDTO} from "../../_models/rapport-dto";
import {RapportService} from "../../../services/rapport-service/rapport.service";
import {Endpoints} from "../../endpoints";
import { finalize, forkJoin, tap } from 'rxjs';
import { SampleService } from '../../../services/sample-service/sample.service';
import saveAs from 'file-saver';
import { SampleDTO } from '../../_models/sampleDTO';
import { DevisService } from '../../../services/devis-service/devis.service';
import { Router } from '@angular/router';
import { ClientsService } from '../../../services/client-service/clients.service';
import { TypeAnalyseService } from '../../../services/type-analyse-service/type.analyse.service';
import { MatIconModule } from '@angular/material/icon';
import { SafePipe } from '../../../safe.pipe';
import { BonCommandeDTO } from '../../_models/bonCommandeDTO';

@Component({
    selector: 'app-devis',
    standalone: true,
    providers: [DialogService, SafePipe,HandleErrorsService, RapportService, Endpoints],
    imports: [        SafePipe,

        DatePipe,
        FormsModule,
        MatButton,MatIconModule,
        MatCard,
        MatCardContent,
        MatCardHeader,
        MatCardSubtitle,
        MatCardTitle,
        MatCell,
        MatCellDef,
        MatCheckbox,
        MatColumnDef,
        MatDatepicker,
        MatDatepickerInput,
        MatDatepickerToggle,
        MatError,
        MatFormField,
        MatHeaderCell,
        MatHeaderRow,
        MatHeaderRowDef,
        MatInput,
        MatLabel,
        MatMenu,
        MatOption,
        MatPaginator,
        MatRow,
        MatRowDef,
        MatSelect,
        MatSort,
        MatSortHeader,
        MatSuffix,
        MatTab,
        MatTabGroup,
        MatTable,
        MatTooltip,
        NgForOf,
        NgIf,
        ReactiveFormsModule,
        MatHeaderCellDef,
        MatMenuTrigger,
        NgClass,
        MatNoDataRow,
        CommonModule
    ],
    templateUrl: './bonsCommande.component.html',
    styleUrl: './bonsCommande.component.scss'
})
export class BonsCommandeComponent implements OnInit, OnChanges, AfterViewInit {
editModal: TemplateRef<BonCommandeDTO>;
menu: MatMenuPanel<any>|null;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    form: FormGroup;
    searchValue: string = '';
    bonsCommande?: BonCommandeDTO;
    rapportId: number; 
    loadingDevis: boolean = false;
    dataSource: MatTableDataSource<BonCommandeDTO> = new MatTableDataSource<BonCommandeDTO>();
    selectedBonsCommande: Set<BonCommandeDTO> = new Set<BonCommandeDTO>(); 
    isAllBonsCommandeSelected: boolean = false;
    sampleIds: number[] = []; 

    displayedColumns: string[] = [
        'select',  
        'numeroBonsCommande',
        'dateCreation',
        'dateLivraison',
        'delaiLivraison',
        'methodeExpedition',
        'conditionReglement',
        'totalHT',
        'totalTTC',
        //'clientNom',  
        'typeAnalyseNom',  
        'action'
      ];  

    columns: string[] = [...this.displayedColumns];

    loadingTable: boolean = true;
    loadingOT: boolean = false;
    loadingPdfGen: boolean = false; 
    viewModal: TemplateRef<BonCommandeDTO>;

    constructor(
        private cookieService: CookieService,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private cdr: ChangeDetectorRef,
        private overlayContainer: OverlayContainer,
        private devisService:DevisService,
        private handleErrors: HandleErrorsService,
        private clientService: ClientsService,
        private typeAnalyseService: TypeAnalyseService
    ) {
        this.initializeForm();
    }
    clients: any[] = [];
    typeAnalyses: any[] = [];
    Form: FormGroup;
    detailForm!: FormGroup;
    statuses: string[] = [];  
    detailsList: any[] = [];


    ngOnInit() {
      this.form = this.fb.group({
        id: ['', Validators.required],  
        //numeroDevis: ['', Validators.required],
        clientId: ['', Validators.required],
        dateCreation: ['', Validators.required],
        dateExpiration: ['', Validators.required],
        dateLivraison: ['', Validators.required],
        delaiLivraison: ['', Validators.required],
        methodeExpedition: ['', Validators.required],
        conditionReglement: ['', Validators.required],
        validite: ['', Validators.required],
        status: ['', Validators.required],
        tvaApplicable: [null],  
        details: this.fb.array([])  
    }); 
    this.detailForm = this.fb.group({
      typeAnalyseId: [null, Validators.required],
      qte: [null, Validators.required],
      prixUnitaire: [null, Validators.required]
    });
          this.Form = this.fb.group({
           // numeroDevis: ['', Validators.required],
            clientId: ['', Validators.required],
            dateCreation: ['', Validators.required],
            dateExpiration: ['', Validators.required],
            dateLivraison: ['', Validators.required],
            delaiLivraison: ['', Validators.required],
            methodeExpedition: ['', Validators.required],
            conditionReglement: ['', Validators.required],
            validite: ['', Validators.required],
            status: ['', Validators.required],
            tvaApplicable: [false],  
            details: this.fb.array([])  
          });
          
        console.log('Chargement des données...');
        this.loadClients();
        this.loadTypeAnalyses();
        this.fetchDevisList(); 
        this.loadClientsAndTypeAnalyses()
    }
    onTypeAnalyseChangex() {
      const selectedId = this.detailForm.get('typeAnalyseId')?.value;
      console.log('Selected Type Analyse ID:', selectedId);  
      
      const selected = this.typeAnalyses.find(t => t.id === selectedId);
      console.log('Selected Type Analyse:', selected);  
      
      if (selected) {
        this.detailForm.get('prixUnitaire')?.setValue(selected.prix);
        console.log('Prix Unitaire mis à jour:', selected.prix);  
      }
    }

    pdfPreviewUrl: string | null = null;
    showPdfPreview(pdfBase64: string | undefined): void {
      console.log('PDF Base64:', pdfBase64);  // Vérifie la valeur ici
      if (pdfBase64) {
        this.pdfPreviewUrl = pdfBase64;
      } else {
        console.error("Le PDF n'est pas disponible.");
      }
    }
    

  setDetails(details: any[]): void {
    const control = <FormArray>this.form.controls['details'];
    details.forEach(d => {
      control.push(this.fb.group({
        id: [d.id],
        typeAnalyseId: [d.typeAnalyseId, Validators.required],
        qte: [d.qte, Validators.required],
        prixUnitaire: [d.prixUnitaire, Validators.required],
        typeAnalyseNom: [d.typeAnalyseNom]
      }));
    });
  }

    
    addDetailx() {
      if (this.detailForm.valid) {
        this.detailsList.push(this.detailForm.value);
        const newDetail = this.fb.group({
          typeAnalyseId: [this.detailForm.value.typeAnalyseId, Validators.required],
          qte: [this.detailForm.value.qte, Validators.required],
          prixUnitaire: [this.detailForm.value.prixUnitaire, Validators.required]
        });
    
        (this.Form.get('details') as FormArray).push(newDetail);
        this.detailForm.setValue({
          typeAnalyseId: null,
          qte: null,
          prixUnitaire: null
        });
    
        this.detailForm.markAsPristine();
        this.detailForm.markAsUntouched();
      }
    }
    
    addDetailf() {
      if (this.detailForm.valid) {
        this.detailsList.push(this.detailForm.value);
        const newDetail = this.fb.group({
          typeAnalyseId: [this.detailForm.value.typeAnalyseId, Validators.required],
          qte: [this.detailForm.value.qte, Validators.required],
          prixUnitaire: [this.detailForm.value.prixUnitaire, Validators.required]
        });
    
        (this.form.get('details') as FormArray).push(newDetail);
        this.detailForm.setValue({
          typeAnalyseId: null,
          qte: null,
          prixUnitaire: null
        });
    
        this.detailForm.markAsPristine();
        this.detailForm.markAsUntouched();
      }
    }

    removeDetailx(index: number) {
      this.detailsList.splice(index, 1);
      this.Form.get('details')?.setValue(this.detailsList);
      this.Form.get('details')?.markAsDirty();
      this.Form.get('details')?.updateValueAndValidity();
    }
    removeDetailF(index: number) {
      this.detailsList.splice(index, 1);
      const detailsFormArray = this.form.get('details') as FormArray;
      detailsFormArray.removeAt(index); 
      detailsFormArray.markAsDirty();
      detailsFormArray.updateValueAndValidity();
    }
   
    getTypeAnalyseName(id: number): string {
      const type = this.typeAnalyses.find(t => t.id === id);
      return type ? type.codeAT : '';
    }
    getTypeAnalyseDesc(id: number): string {
      const type = this.typeAnalyses.find(t => t.id === id);
      return type ? type.description : '';
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes['dataSource']) {
            this.initializeForm();
        }
    }
      createDetail(): FormGroup {
        return this.fb.group({
          typeAnalyseId: ['', Validators.required], 
          qte: ['', Validators.required],  
          prixUnitaire: ['', Validators.required], 
        });
      }
      
      get details(): FormArray {
        return this.Form.get('details') as FormArray;
      }
      
      loadClients(): void {
        console.log('Chargement des clients...');
      
        this.clientService.loadClients().subscribe(
          (response) => {
            console.log('Réponse brute des clients:', response); 
            console.log('Clients chargés avec succès:', response.data); 
            this.clients = response.data; 
          },
          (error) => {
            console.error('Erreur lors du chargement des clients:', error);
          }
        );
    }
    
      prixUnitaire: number = 0; 
      loadTypeAnalyses(): void {
        this.typeAnalyseService.getAllTypeAnalyses().subscribe(
            (response) => {
                if (Array.isArray(response)) {
                    console.log("Types d'analyses chargés avec succès:", response);
                    this.typeAnalyses = response;
                } else {
                    console.error("La réponse API ne contient pas un tableau de types d'analyses", response);
                }
            },
            (error) => {
                console.error("Erreur lors du chargement des types d'analyses:", error);
            }
        );
    }

    loadClientsAndTypeAnalyses() {
      console.log('Chargement des clients et des types d\'analyses...');
      
      forkJoin({
        clients: this.clientService.loadClients(),
        typeAnalyses: this.typeAnalyseService.getAllTypeAnalyses()
      }).subscribe({
        next: (responses) => {
          if (Array.isArray(responses.typeAnalyses)) {
            console.log('Types d\'analyses chargés avec succès:', responses.typeAnalyses);
            this.typeAnalyses = responses.typeAnalyses;  
          } else {
            console.error("La réponse des types d'analyses ne contient pas un tableau dans 'data'", responses.typeAnalyses);
          }
          if (Array.isArray(responses.clients.data)) {
            console.log('Clients chargés avec succès:', responses.clients.data);
            this.clients = responses.clients.data; 
          } else {
            console.error("La réponse des clients ne contient pas un tableau dans 'data'", responses.clients);
          }
          this.fetchDevisList();
        },
        error: (error) => {
          console.error('Erreur lors du chargement des clients et des types d\'analyses:', error);
        }
      });
    }

  onTypeAnalyseChange(): void {
    const selectedTypeAnalyseId = this.Form.get('typeAnalyseId')?.value;
    const selectedTypeAnalyse = this.typeAnalyses.find(
      (type) => type.id === selectedTypeAnalyseId
    );

    if (selectedTypeAnalyse) {
      this.prixUnitaire = selectedTypeAnalyse.prix; 
      this.Form.get('prixUnitaire')?.setValue(this.prixUnitaire);
    }
  }
    selectedTypeAnalyse: any = null;  
  
    ngAfterViewInit() {
        this.initializePaginatorAndSort();
    }

    initializePaginatorAndSort() {
        this.overlayContainer.getContainerElement().style.zIndex = '2000';
        this.dataSource.filter = this.searchValue;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'desc';
    }
    initializeForm() {
        this.form = this.fb.group({
          //  numeroDevis: ['', Validators.required],
            clientId: ['', Validators.required],
            dateCreation: ['', Validators.required],
            dateExpiration: ['', Validators.required],
            dateLivraison: ['', Validators.required],
            delaiLivraison: ['', Validators.required],
            methodeExpedition: ['', Validators.required],
            conditionReglement: ['', Validators.required],
            validite: ['', Validators.required],
            typeAnalyseId: ['', Validators.required],
            prixUnitaire: ['', Validators.required],
            status: ['', Validators.required],
        });
    }
    getClientNom(clientId: number): string {
        console.log('Client ID:', clientId);  
        const client = this.clients.find(c => c.id === clientId);
        console.log('Client trouvé:', client); 
        return client ? client.socialReason : 'Client non trouvé';
    }      getTypeAnalyseNom(typeAnalyseId: number): string {
        const typeAnalyse = this.typeAnalyses.find(t => t.id === typeAnalyseId);
        return typeAnalyse ? typeAnalyse.codeAT : 'Type d\'analyse non trouvé';
      }
    
   fetchDevisList() {
        console.log('Chargement des devis...');       
        this.devisService.fetchAllBDC().subscribe({
          next: response => {
            console.log('Réponse reçue:', response);
            if (Array.isArray(response)) {
              this.dataSource.data = response.map(devis => {
                devis.details.forEach((detail: { typeAnalyseNom: string; typeAnalyseId: number }) => {
                  detail.typeAnalyseNom = this.getTypeAnalyseNom(detail.typeAnalyseId);
                });
                return {
                  ...devis,
                  clientNom: this.getClientNom(devis.clientId),
                  details: devis.details  
                };
              });
            } else if (response.status && Array.isArray(response.data)) {
              this.dataSource.data = response.data.map(devis => {
                devis.details.forEach((detail: { typeAnalyseNom: string; typeAnalyseId: number }) => {
                  detail.typeAnalyseNom = this.getTypeAnalyseNom(detail.typeAnalyseId);
                });  
                return {
                  ...devis,
                  clientNom: this.getClientNom(devis.clientId),
                  details: devis.details
                };
              });
            } else {
              console.error('Format de réponse inattendu:', response);
            }
      
            this.loadingTable = false;
          },
          error: err => {
            this.handleErrors.catchError(err);
            this.loadingTable = false;
          }
        });
      }
      
      openEditModal(element: BonCommandeDTO, editModal: TemplateRef<BonCommandeDTO>) {
        console.log('Edition du devis:', element);
        console.log('Valeur de TVA Applicable:', element.tvaApplicable);
        this.form.patchValue({
          id: element.id,
          numeroBonsCommande: element.numeroBonsCommande,
          clientId: element.clientId,
          dateCreation: element.dateCreation,
          dateLivraison: element.dateLivraison,
          delaiLivraison: element.delaiLivraison,
          methodeExpedition: element.methodeExpedition,
          conditionReglement: element.conditionReglement,
          status: element.status,  
          tvaApplicable: element.tvaApplicable,
        });
        this.bonsCommande = { ...element }; 

        const detailsFormArray = this.form.get('details') as FormArray;
        detailsFormArray.clear();
      
        if (element.details && Array.isArray(element.details)) {
          element.details.forEach(detail => {
            detailsFormArray.push(this.fb.group({
              id: [detail.id],
              typeAnalyseId: [detail.typeAnalyseId, Validators.required],
              qte: [detail.qte, Validators.required],
              prixUnitaire: [detail.prixUnitaire, Validators.required],
            }));
          });
        } else {
          console.warn('⚠️ Aucun détail dans le devis.');
        }
      
        this.cdr.detectChanges();
        this.modalService.open(editModal, { ariaLabelledBy: 'modal-basic-title', size: 'xl' });
      }
      

    updateTableRow(updatedData: any) {
        const index = this.dataSource.data.findIndex(item => item.id === updatedData.id);
        if (index !== -1) {
            this.dataSource.data[index] = updatedData;
        }
    }

  confirmDelete(element: any) {
        this.dialogService.open(
            "Êtes-vous sûr de vouloir supprimer ce devis ?",
            environment.warning_message_type,
            'danger',
            environment.warning_icon,
            true
        ).then((result: any) => {
            if (result) {
                this.deleteBDC(element.id);
            }
        });
    }

    deleteBDC(id: number) {
      console.log("Suppression du devis avec l'id:", id);
      this.devisService.deleteBDC(id).pipe(
        tap((response: any) => {
          if (response.status) {
              this.removeTableRow(id);
              this.dialogService.openSuceessAlert('Bons de Commande supprimé avec succès' );
          }
      }),
      finalize(() => {
          this.dataSource.paginator = this.paginator;
      })
  ).subscribe();
  }
  

    removeTableRow(id: number) {
      this.dataSource.data = this.dataSource.data.filter(sample => sample.id !== id);
      this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
  }
    applyFilter(event: Event) {
        this.searchValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
        this.dataSource.filter = this.searchValue;
    }

    handleSelection(bonsCommande: BonCommandeDTO) {
        if (this.selectedBonsCommande.has(bonsCommande)) {
            this.selectedBonsCommande.delete(bonsCommande);  
            console.log(`Bons de Commande avec ID ${bonsCommande.id} a été désélectionné`);
        } else {
            this.selectedBonsCommande.add(bonsCommande); 
            console.log(`Bons de Commande  avec ID ${bonsCommande.id} a été sélectionné`);
        }
    
        console.log('Rapports sélectionnés:', Array.from(this.selectedBonsCommande).map(item => item.id));
    }
    openModal(content: any) {
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'xl'}).result.then(
            () => {
                this.form.reset()
            },
            () => {
                this.form.reset()
            }
        );
    }

    saveDevis(): void {
      console.log('Formulaire valide:', this.Form.valid);  
      if (this.Form.valid) {
          console.log('Formulaire valide, préparation des données à soumettre');
          const devis = this.Form.value;
          console.log('Données du devis à envoyer:', devis);
  
          this.devisService.createDevis(devis).subscribe(
              (response) => {
                  console.log('Devis créé avec succès:', response);
                  this.Form.reset();
                  this.modalService.dismissAll(); 
                  this.fetchDevisList();
              },
              (error) => {
                console.error('Erreur lors de la création du devis:', error);
            
                const backendMessage = error?.error?.message;
                const message = backendMessage
                    ? backendMessage
                    : 'Une erreur est survenue lors de la création du devis.';
            
                this.dialogService.openDangerAlert(message); // ou utilisez un toast/snackbar si disponible
            }
          );
      } else {
          console.log('Formulaire invalide, vérifiez les champs');
          Object.keys(this.Form.controls).forEach((controlName) => {
              const control = this.Form.get(controlName);
              if (control && control.invalid) {
                  console.log(`Le champ ${controlName} est invalide. Erreurs:`, control.errors);
              }
          });
      }
  }
  
      
    handleSelectAll() {
        this.isAllBonsCommandeSelected = !this.isAllBonsCommandeSelected;
        this.selectedBonsCommande = this.isAllBonsCommandeSelected
            ? new Set<BonCommandeDTO>(this.dataSource.filteredData)
            : new Set<BonCommandeDTO>();
    }

    handleIsAllColsSelected(event: MatCheckboxChange) {
        this.displayedColumns = event.checked ? [...this.columns] : [];
        this.setColsCookie();
    }

    getdisplayedCol = (): string[] => {
        return ['select', ...this.displayedColumns, 'action'];
    };

    onSelectionChange(column: string): void {
        this.displayedColumns = this.displayedColumns.includes(column)
            ? this.displayedColumns.filter(c => c !== column)
            : [...this.displayedColumns, column];
        this.setColsCookie();
    }

    user_name = sessionStorage.getItem('user_name');



    private setColsCookie() {
        this.cookieService.set(`devisCol_${this.user_name}`, JSON.stringify(this.displayedColumns), {
            expires: 7,
            path: '/',
            secure: true
        });
    }

    private getColsCookie() {
        const reportCols = this.cookieService.get(`devisCol_${this.user_name}`);
        if (reportCols) {
            this.displayedColumns = JSON.parse(reportCols);
            console.log('Colonnes récupérées:', reportCols);
        }
    }
    generateDevis(id: number) {
      this.loadingDevis = true;
      if (!id) {
          this.dialogService.openDangerDialog('Aucun bdc sélectionné');
          this.loadingDevis = false;
          return;
      }
      console.log('ID du devis envoyé au backend:', id);
      this.devisService.downloadBDC([id]).subscribe(
          (response: Blob) => {
              console.log(`PDF reçu pour le devis avec ID: ${id}`);
  
              const blob = new Blob([response], { type: 'application/pdf' });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `bonsCommande_${id}.pdf`; 
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
  
              console.log(`PDF pour le devis avec ID ${id} téléchargé avec succès.`);
          },
          (error) => {
              console.error(`Erreur lors du téléchargement du devis avec ID: ${id}`, error);
              this.dialogService.openDangerDialog('Erreur lors du téléchargement du devis');
          }
      );
  
      this.loadingDevis = false;
  }
  loadDevisForEdit(devis: any) {
    this.form.patchValue({
      id: devis.id,
      numeroBonCommande: devis.numeroBonCommande,
      dateCreation: devis.dateCreation,
      dateLivraison: devis.dateLivraison,
      tvaApplicable: devis.tvaApplicable ?? false,
      clientId: devis.clientId,
      delaiLivraison: devis.delaiLivraison,
      methodeExpedition: devis.methodeExpedition,
      conditionReglement: devis.conditionReglement,
    });
  
    const detailsFormArray = this.form.get('details') as FormArray;
    detailsFormArray.clear(); 
  
    devis.details.forEach((d: any) => {
      detailsFormArray.push(this.fb.group({
        id: [d.id],
        typeAnalyseId: [d.typeAnalyseId, Validators.required],
        qte: [d.qte, Validators.required],
        prixUnitaire: [d.prixUnitaire, Validators.required]
      }));
    });
    
  }
  get detailsArray() {
    return (this.form.get('details') as FormArray);
  }
  
  
}